import React, { useState } from "react";
import { MDBSideNavItem, MDBSideNavLink, MDBSideNavCollapse, MDBSelect } from "mdb-react-ui-kit";

const FilterSessionSelect = ({ sessions, filterSession, setFilterSession }) => {
    const [collapse, setCollapse] = useState(false);

// Function to transform the session label based on the last digit of session.ordinals
const transformSessionLabel = (sessionOrdinal) => {
    const lastDigit = sessionOrdinal.slice(-1); // Get the last character of ordinals (e.g., "20251" -> "1")

    // If the last number is "1", it will return (Regular), else (Special)
        return lastDigit === "1"
            ? sessionOrdinal.replace(/1$/, "") + " (Regular)"
            : sessionOrdinal.replace(/\d$/, "") + " (Special)";
    };

  // Create session options with transformed labels
  const sessionOptions = sessions.map((session) => ({
    text: transformSessionLabel(session.ordinals),
    value: session.id,
  }));

  // Default to the first session if no filterSession.id is provided
  const selectedSession = filterSession?.id || sessions[0]?.id;

    return (
        <MDBSideNavItem>
            <MDBSideNavLink
                className="accordion-button"
                icon="angle-down"
                shouldBeExpanded={collapse}
                onClick={() => setCollapse(!collapse)}
            >
                Standing
            </MDBSideNavLink>
            <MDBSideNavCollapse open={collapse}>
                <li className="p-3">
                    <MDBSelect
                        data={sessionOptions}
                        value={selectedSession}
                        search
                        label="Select Session"
                        onChange={(value) => {
                            const selectedSession = sessions.find((item) => item.id === value.value);
                            setFilterSession(selectedSession);
                        }}
                    />
                </li>
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};

export default FilterSessionSelect;